<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="delete-modal">
      <div class="flex justify-center">
        <svg
          width="93"
          height="93"
          viewBox="0 0 93 93"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_11_19018)">
            <path
              d="M92.6003 46.3001C92.6003 71.8711 71.8711 92.6003 46.3001 92.6003C20.7291 92.6003 0 71.8711 0 46.3001C0 20.7291 20.7291 0 46.3001 0C71.8711 0 92.6003 20.7291 92.6003 46.3001Z"
              fill="#FFF2E0"
            />
            <path
              d="M86.3568 46.3C86.3568 68.4227 68.4231 86.3564 46.3005 86.3564C24.1778 86.3564 6.24414 68.4227 6.24414 46.3C6.24414 24.1774 24.1778 6.24365 46.3005 6.24365C68.4231 6.24365 86.3568 24.1774 86.3568 46.3Z"
              fill="#FFF2E0"
            />
            <path
              d="M76.1588 55.7309C76.1588 49.9476 72.2046 45.0884 66.8522 43.71V28.6315C66.8522 27.1827 65.8268 25.9732 64.462 25.6884C64.178 24.3244 62.9685 23.2989 61.5196 23.2989H50.8225L48.4179 20.8943H27.2025C25.5424 20.8943 24.1973 22.2401 24.1973 23.9003V67.8472C24.1973 69.3188 25.2553 70.5435 26.6519 70.8025C26.8738 71.9991 27.8039 72.9466 28.9914 73.1943C29.2754 74.559 30.4849 75.5845 31.9338 75.5845H63.8462C65.5064 75.5845 66.8515 74.2379 66.8515 72.5785V67.7518C72.2046 66.3727 76.1588 61.5134 76.1588 55.7309V55.7309Z"
              fill="#FFE5C2"
            />
            <path
              d="M63.8455 72.8694H31.9337C30.2736 72.8694 28.9277 71.5235 28.9277 69.8642V27.119C28.9277 25.4589 30.2736 24.113 31.9337 24.113H63.8455C65.5057 24.113 66.8515 25.4589 66.8515 27.119V69.8634C66.8515 71.5235 65.5057 72.8694 63.8455 72.8694V72.8694Z"
              fill="#D1D3D4"
            />
            <path
              d="M63.8455 71.6666H31.9337C30.2736 71.6666 28.9277 70.3216 28.9277 68.6614V25.9171C28.9277 24.257 30.2736 22.9111 31.9337 22.9111H63.8455C65.5057 22.9111 66.8515 24.257 66.8515 25.9171V68.6614C66.8515 70.3216 65.5057 71.6666 63.8455 71.6666Z"
              fill="white"
            />
            <path
              d="M61.5192 70.5428H29.6075C27.9474 70.5428 26.6016 69.197 26.6016 67.5376V24.7924C26.6016 23.1322 27.9474 21.7864 29.6075 21.7864H61.5192C63.1793 21.7864 64.5252 23.1322 64.5252 24.7924V67.5368C64.5252 69.197 63.1793 70.5428 61.5192 70.5428V70.5428Z"
              fill="#D1D3D4"
            />
            <path
              d="M61.5192 69.34H29.6075C27.9474 69.34 26.6016 67.9949 26.6016 66.3348V23.5905C26.6016 21.9303 27.9474 20.5845 29.6075 20.5845H61.5192C63.1793 20.5845 64.5252 21.9303 64.5252 23.5905V66.3348C64.5252 67.9949 63.1793 69.34 61.5192 69.34Z"
              fill="#E6E7E8"
            />
            <path
              d="M49.6199 19.3818H27.2025C25.5424 19.3818 24.1973 20.7277 24.1973 22.3878V65.1322C24.1973 66.7923 25.5424 68.1382 27.2025 68.1382H59.115C60.7751 68.1382 62.1202 66.7923 62.1202 65.1322V31.883L49.6199 19.3818Z"
              fill="#D1D3D4"
            />
            <path
              d="M48.4179 18.1799H27.2025C25.5424 18.1799 24.1973 19.525 24.1973 21.1852V63.9295C24.1973 65.5896 25.5424 66.9355 27.2025 66.9355H59.115C60.7751 66.9355 62.1202 65.5896 62.1202 63.9295V31.883L48.4179 18.1799Z"
              fill="white"
            />
            <path
              d="M56.1428 38.3492H30.1726C29.5092 38.3492 28.9707 37.8115 28.9707 37.1473C28.9707 36.4831 29.5084 35.9446 30.1726 35.9446H56.1428C56.807 35.9446 57.3455 36.4823 57.3455 37.1473C57.3455 37.8115 56.807 38.3492 56.1428 38.3492Z"
              fill="#D0D2D3"
            />
            <path
              d="M56.1428 45.6434H30.1726C29.5092 45.6434 28.9707 45.1049 28.9707 44.4407C28.9707 43.7773 29.5084 43.2388 30.1726 43.2388H56.1428C56.807 43.2388 57.3455 43.7765 57.3455 44.4407C57.3455 45.1049 56.807 45.6434 56.1428 45.6434Z"
              fill="#D0D2D3"
            />
            <path
              d="M56.1428 52.9378H30.1726C29.5092 52.9378 28.9707 52.3993 28.9707 51.735C28.9707 51.0707 29.5084 50.5322 30.1726 50.5322H56.1428C56.807 50.5322 57.3455 51.0707 57.3455 51.735C57.3455 52.3993 56.807 52.9378 56.1428 52.9378Z"
              fill="#D0D2D3"
            />
            <path
              d="M56.1428 60.2318H30.1726C29.5092 60.2318 28.9707 59.6933 28.9707 59.0291C28.9707 58.3656 29.5084 57.8271 30.1726 57.8271H56.1428C56.807 57.8271 57.3455 58.3649 57.3455 59.0291C57.3455 59.6933 56.807 60.2318 56.1428 60.2318Z"
              fill="#D0D2D3"
            />
            <path
              d="M62.121 31.883H51.424C49.7638 31.883 48.418 30.5372 48.418 28.877V18.1799L62.121 31.883Z"
              fill="#BBBDBF"
            />
            <path
              d="M66.5986 40.9427C59.9277 39.3673 53.2424 43.4988 51.6671 50.1704C50.0917 56.8413 54.2224 63.5266 60.8941 65.1019C67.5657 66.6772 74.251 62.5458 75.8263 55.8749C77.4016 49.2033 73.2702 42.518 66.5986 40.9427V40.9427Z"
              fill="#FBC1CE"
            />
            <path
              d="M66.0047 43.4591C60.7229 42.2117 55.4304 45.4828 54.183 50.764C52.9364 56.0459 56.2067 61.3384 61.4886 62.5858C66.7697 63.8324 72.0621 60.5621 73.3095 55.2802C74.5569 49.999 71.2858 44.7065 66.0047 43.4591V43.4591Z"
              fill="#FDE3E9"
            />
            <path
              d="M59.0397 57.7236C58.3331 57.0169 58.3331 55.871 59.0397 55.1644L65.8947 48.3087C66.6013 47.6028 67.7472 47.6028 68.4538 48.3087C69.1604 49.0153 69.1604 50.1612 68.4538 50.8686L61.5989 57.7236C60.8923 58.4302 59.7464 58.4302 59.0397 57.7236V57.7236Z"
              fill="#D32027"
            />
            <path
              d="M68.4543 57.7236C67.7477 58.4302 66.6018 58.4302 65.8952 57.7236L59.0403 50.8686C58.3329 50.162 58.3329 49.0161 59.0403 48.3087C59.7462 47.6028 60.8921 47.6028 61.5994 48.3087L68.4543 55.1644C69.161 55.871 69.161 57.0169 68.4543 57.7236Z"
              fill="#D32027"
            />
          </g>
          <defs>
            <clipPath id="clip0_11_19018">
              <rect width="92.6" height="92.6" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="my-6">
        <p>Are you sure you want to cancel this Consolidation?</p>
      </div>

      <div>
        <base-button @click="$emit('cancel')" text="Yes, Cancel" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
